module.exports = __webpack_public_path__ + "img/home1.ce36a79d.png";